<template>
  <div class="com_summary_leader">
    <div>
      <div v-for="(leader,index) in leaderArr" :key="index" class="com_leader_cup">
        <div class="leader_img">
          <img :src="leader.icon" alt="" width="146" height="167">
        </div>
        <div class="leader_info">
          <p class="leader_summary" v-html="leader.summary"></p>
        </div>
        <!-- <el-row :gutter="20">
          <el-col :span="6">
            <img :src="leader.icon" alt="" width="146" height="167">
          </el-col>
          <el-col :span="18">
            <div class="leader_summary" v-html="leader.summary"></div>
          </el-col>
        </el-row> -->
      </div>
    </div>
  </div>
</template>
<script>
import { leadersCompany } from '@/api/frontApi/company';
export default {
  data() {
    return {
      leaderArr: [
        {
          icon: '../../../../static/img/leader/p-zys.png',
          name: '赵剡水',
          jobTitle: '董事长',
          summary:
            '工学博士，教授级高级工程师，中国一拖集团有限公司董事长、总经理、兼任中国农机工业协会副会长、中国农业机械学会副理事长等职务。'
        },
        {
          icon: '../../../../static/img/leader/p-yjh.png',
          name: '袁进宏',
          jobTitle: '总经理',
          summary:
            '工学博士，国家千人计划，中国科学院计算技术研究所研究员，曾任澳大利亚新南威尔士大学教授，网络通信领域国际知名专家。'
        },
        {
          icon: '../../../../static/img/leader/p-wyf.png',
          name: '王云飞',
          jobTitle: '常务副总经理',
          summary:
            '王云飞，教授级高工，洛阳市学科带头人、洛阳市优秀科技专家，中国机械工程学会失效分析专家，全国锻压技术标准委员会副主任，全国钢标准化技术委员会金相检验技术委员会委员，在自动化制造系统、智能生产系统的研发和应用等方面工作业绩显著。'
        },
        {
          icon: '../../../../static/img/leader/p-zcj.png',
          name: '赵春江',
          jobTitle: '创新中心主任',
          summary:
            '中国工程院院士，国家农业信息化工程技术研究中心主任、首席专家。主要从事人工智能、专家系统、数据挖掘、网络中间件技术等领域的研究与应用。'
        }
      ]
    };
  },
  created() {
    this.initLeaders();
  },
  methods: {
    initLeaders() {
      this.leaderArr = [];
      leadersCompany().then(res => {
        if (res.data.length) {
          res.data.forEach(item => {
            let tempObj = {
              icon: '',
              name: '',
              jobTitle: '',
              summary: ''
            };
            tempObj.icon = item.leadImg;
            tempObj.name = item.leadName;
            tempObj.jobTitle = item.leadImg;
            tempObj.summary = item.leadBody;
            this.leaderArr.push(tempObj);
          });
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.com_leader_cup {
  border: 1px solid #DCDFE6;
  padding: 10px 10px;
  margin-bottom: 10px;
  font-size: 16px;
  overflow: hidden;
  width: 100%;
  min-width: 680px;

  .leader_img {
    float: left;
    width: 20%;
    min-width: 150px;
  }

  .leader_info {
    float: left;
    width: 76%;
    margin-left: 8px;
    min-width: 450px;
  }

  .leader_summary {
    color: #000;
    max-height: 171px;
  }

  .leader_summary>>>p {
    color: #000;
    line-height: 20px;
    height: 20px;
  }

  img {
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/companyInfos/companyLeaders.vue